import service from '@/utils/request';

// @Summary 封禁角色列表
export var banRoleList = function banRoleList(data) {
  return service({
    url: "/xcpOpsManager/role/banRoleList",
    method: 'post',
    data: data
  });
};
export var banRoleLogin = function banRoleLogin(data) {
  return service({
    url: "/xcpOpsManager/role/banRoleLogin",
    method: 'post',
    data: data
  });
};
export var unbanRoleLogin = function unbanRoleLogin(data) {
  return service({
    url: "/xcpOpsManager/role/unBanRoleLogin",
    method: 'post',
    data: data
  });
};

// 禁言
export var banRoleChatList = function banRoleChatList(data) {
  return service({
    url: "/xcpOpsManager/role/banRoleChatList",
    method: 'post',
    data: data
  });
};
export var banRoleChat = function banRoleChat(data) {
  return service({
    url: "/xcpOpsManager/role/banRoleChat",
    method: 'post',
    data: data
  });
};
export var unbanRoleChat = function unbanRoleChat(data) {
  return service({
    url: "/xcpOpsManager/role/unBanRoleChat",
    method: 'post',
    data: data
  });
};

//封帐号
export var banOpenidList = function banOpenidList(data) {
  return service({
    url: "/xcpOpsManager/role/banOpenidList",
    method: 'post',
    data: data
  });
};
export var banOpenidLogin = function banOpenidLogin(data) {
  return service({
    url: "/xcpOpsManager/role/banOpenidLogin",
    method: 'post',
    data: data
  });
};
export var unbanOpenidLogin = function unbanOpenidLogin(data) {
  return service({
    url: "/xcpOpsManager/role/unBanOpenidLogin",
    method: 'post',
    data: data
  });
};

//封IP
export var banIpList = function banIpList(data) {
  return service({
    url: "/xcpOpsManager/role/banIpList",
    method: 'post',
    data: data
  });
};
export var banIpLogin = function banIpLogin(data) {
  return service({
    url: "/xcpOpsManager/role/banIpLogin",
    method: 'post',
    data: data
  });
};
export var unbanIpLogin = function unbanIpLogin(data) {
  return service({
    url: "/xcpOpsManager/role/unBanIpLogin",
    method: 'post',
    data: data
  });
};
export var ipUserCountList = function ipUserCountList(data) {
  return service({
    url: "/xcpOpsManager/role/ipUserCountList",
    method: 'post',
    data: data
  });
};
export var userRoleListByIp = function userRoleListByIp(data) {
  return service({
    url: "/xcpOpsManager/role/userRoleListByIp",
    method: 'post',
    data: data
  });
};
export var userAccountListByIp = function userAccountListByIp(data) {
  return service({
    url: "/xcpOpsManager/role/userAccountListByIp",
    method: 'post',
    data: data
  });
};
export var multiBanRoleLogin = function multiBanRoleLogin(data) {
  return service({
    url: "/xcpOpsManager/role/multiBanRoleLogin",
    method: 'post',
    data: data
  });
};